import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import FloatingWhatsapp from "@/components/FloatingWhatsapp";
import MobileBottomNav from "@/components/MobileBottomNav";
import { useSeo } from "@/lib/seo";

/**
 * Wrapper for a single section rendered on its own route.
 * Adds a "Volver" button and page-level chrome so mobile back button works naturally.
 */
export default function SectionPage({ title, seoTitle, seoDescription, canonical, children }) {
  useSeo({ title: seoTitle, description: seoDescription, canonical });
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <div data-testid="section-page" className="pb-[calc(env(safe-area-inset-bottom)+72px)] sm:pb-0">
      <Header />
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-16 pb-1">
        <Link
          to="/"
          data-testid="section-page-back"
          className="inline-flex items-center gap-1.5 text-sm font-bold text-[var(--faro-blue)] hover:text-[var(--faro-red)] transition-colors"
        >
          <ArrowLeft size={16} /> Volver al inicio
        </Link>
        {title && (
          <h1 className="sr-only">{title}</h1>
        )}
      </div>
      <main>{children}</main>
      <Footer />
      <FloatingWhatsapp />
      <MobileBottomNav />
    </div>
  );
}
